import BasicLink from 'core/BasicLink';

import cn from './style.module.sass';

type ContactsRightProps = {
    currentCity: 'moscow' | 'rostov';
};

export default function ContactsRight({ currentCity }: ContactsRightProps) {
    return (
        <div className={cn['contacts__container-right']}>
            <div className={cn['contacts__subtitle-container']}>
                {currentCity === 'moscow' && (
                    <BasicLink href="tel:84955405179" className={cn['contacts__subtitle']}>
                        +7 495 540-51-79
                    </BasicLink>
                )}
                {currentCity === 'rostov' && (
                    <BasicLink href="tel:88633032039" className={cn['contacts__subtitle']}>
                        +7 863 303-20-39
                    </BasicLink>
                )}
                <BasicLink href="mailto:info@webpractik.ru" className={cn['contacts__link']}>
                    info@webpractik.ru
                </BasicLink>
            </div>

            <div className={cn['contacts__mail-item']}>
                <div className={cn['contacts__mail-label']}>Для сотрудничества</div>
                <BasicLink href="mailto:pr@webpractik.ru" className={cn['contacts__link']}>
                    pr@webpractik.ru
                </BasicLink>
            </div>

            <div className={cn['contacts__mail-item']}>
                <div className={cn['contacts__mail-label']}>Для работы в команде</div>
                <BasicLink href="mailto:hr@webpractik.ru" className={cn['contacts__link']}>
                    hr@webpractik.ru
                </BasicLink>
            </div>
        </div>
    );
}
